export const ALLOWED_FILE_EXTENSIONS = ['ps6', 'pa6', 'py', 'rb']